import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { BootstrapCustomElements } from '../../decorators/bootstrap-custom-elements.decorator';
import { SharedModule } from '../../shared.module';
import { WebComponentControlModule } from '../../web-component-control.module';
import { StatusBadgeComponent } from './status-badge.component';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [StatusBadgeComponent],
  exports: [StatusBadgeComponent],
  imports: [
    CommonModule,
    SharedModule,
  ]
})
@BootstrapCustomElements([
  StatusBadgeComponent
])
export class HlsStatusBadgeModule extends WebComponentControlModule { }
